import { create } from "zustand";
import { persist } from "zustand/middleware";

/** Ancho del drawer lateral expandido (porcentaje del viewport). */
export const SIDEBAR_EXPANDED_WIDTH = "17%";
/** Ancho del drawer lateral colapsado (solo iconos). */
export const SIDEBAR_COLLAPSED_WIDTH = "72px";

interface SidebarStore {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (collapsed: boolean) => void;
}

export const useSidebarStore = create<SidebarStore>()(
  persist(
    (set) => ({
      collapsed: false,
      toggle: () => set((s) => ({ collapsed: !s.collapsed })),
      setCollapsed: (collapsed) => set({ collapsed }),
    }),
    {
      name: "sidebar-storage",
    }
  )
);

export const sidebarWidth = (collapsed: boolean): string =>
  collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_EXPANDED_WIDTH;

/**
 * Márgenes del contenido para acompañar el ancho del drawer. Las pantallas
 * usan esto en su Container principal para reacomodarse al colapsar el menú.
 */
export function useSidebarLayout(): { ml: string; width: string } {
  const collapsed = useSidebarStore((s) => s.collapsed);
  const w = sidebarWidth(collapsed);
  return { ml: w, width: `calc(100% - ${w})` };
}
